export enum AcquiringChannel {
  buyOnlineFicaOnline = 'Bought Online – FICA Online',
  buyInstoreFicaOnline = 'Bought Instore – FICA Online',
  rentOnlineFicaOnline = 'Rented Online – FICA Online',
  zeroRentOnlineFicaOnline = 'Zero Rental Online – FICA Online',
  buyInstoreFicaInstore = 'Bought Instore – FICA Instore',
  vodapay = 'VodaPay BizWallet',
  vodacomBusiness = 'Vodacom Business',
  thirdPartyChannel = '3rd Party',
  noAcquiringChannelSet = 'No Acquiring Channel set',
}

const ACQUIRING_CHANNEL = {
  buyOnlineFicaOnline: 'Bought Online – FICA Online',
  buyInstoreFicaOnline: 'Bought Instore – FICA Online',
  rentOnlineFicaOnline: 'Rented Online – FICA Online',
  zeroRentOnlineFicaOnline: 'Zero Rental Online – FICA Online',
  buyInstoreFicaInstore: 'Bought Instore – FICA Instore',
  vodapay: 'VodaPay BizWallet',
  vodacomBusiness: 'Vodacom Business',
  thirdPartyChannel: '3rd Party',
  noAcquiringChannelSet: 'No Acquiring Channel set',
};

export function getAcquiringChannel(acquiringChannel: string): AcquiringChannel {
  switch (acquiringChannel.toLowerCase()) {
    case ACQUIRING_CHANNEL.buyOnlineFicaOnline.toLowerCase():
      return AcquiringChannel.buyOnlineFicaOnline;

    case ACQUIRING_CHANNEL.buyInstoreFicaOnline.toLowerCase():
      return AcquiringChannel.buyInstoreFicaOnline;

    case ACQUIRING_CHANNEL.rentOnlineFicaOnline.toLowerCase():
      return AcquiringChannel.rentOnlineFicaOnline;

    case ACQUIRING_CHANNEL.zeroRentOnlineFicaOnline.toLowerCase():
      return AcquiringChannel.zeroRentOnlineFicaOnline;

    case ACQUIRING_CHANNEL.buyInstoreFicaInstore.toLowerCase():
      return AcquiringChannel.buyInstoreFicaInstore;

    case ACQUIRING_CHANNEL.vodapay.toLowerCase():
      return AcquiringChannel.vodapay;

    case ACQUIRING_CHANNEL.thirdPartyChannel.toLowerCase():
      return AcquiringChannel.thirdPartyChannel;

    case ACQUIRING_CHANNEL.vodacomBusiness.toLowerCase():
      return AcquiringChannel.vodacomBusiness;

    default:
      return AcquiringChannel.noAcquiringChannelSet;
  }
}
